import React from "react";
import { Button } from "@/components/Button/Button";
import { EntityMultiSelect } from "@/components/EntityMultiSelect/EntityMultiSelect";
import LoadingIndicator from "@/components/LoadingIndicator/LoadingIndicator";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useAddRecurringEmailSubscriberPage } from "@/modules/emailManagement/features/RecurringEmailManagement/hooks/useAddRecurringEmailSubscriberPage";

const AddRecurringEmailSubscriberPage: React.FC = () => {
  const {
    recurringEmails,
    recurringEmail,
    setRecurringEmail,
    employees,
    setEmployees,
    fetchEmployeeOptions,
    isLoading,
    isSubmitting,
    canSubmit,
    submit,
    cancel,
  } = useAddRecurringEmailSubscriberPage();

  return (
    <MainPageWrapper
      subtitle="Subscribe employees to a recurring email."
      title="Add Subscriber"
    >
      {isLoading ? (
        <div className="flex items-center justify-center min-h-[300px]">
          <LoadingIndicator isFullScreen={false} />
        </div>
      ) : (
        <div className="bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg p-6 space-y-6">
          <div className="space-y-2">
            <Label>Recurring email</Label>
            <Select onValueChange={setRecurringEmail} value={recurringEmail}>
              <SelectTrigger>
                <SelectValue placeholder="Select a recurring email" />
              </SelectTrigger>
              <SelectContent>
                {recurringEmails.map((item) => (
                  <SelectItem
                    key={item.recurringEmail}
                    value={item.recurringEmail}
                  >
                    {item.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label>Employees</Label>
            <EntityMultiSelect
              entityNamePlural="Employees"
              entityNameSingular="Employee"
              fetchEntities={fetchEmployeeOptions}
              isFullWidth
              onChange={setEmployees}
              value={employees}
            />
          </div>

          <div className="flex justify-end gap-3">
            <Button className="rounded-md" onClick={cancel} variant="outline">
              Cancel
            </Button>
            <Button
              className="rounded-md"
              disabled={!canSubmit}
              onClick={submit}
              variant="default"
            >
              {isSubmitting ? "Subscribing..." : "Subscribe"}
            </Button>
          </div>
        </div>
      )}
    </MainPageWrapper>
  );
};

export default AddRecurringEmailSubscriberPage;
